export default __webpack_public_path__ + "static/media/wall.4f89e318.png";